import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiProjectPerformance from '../../Api/ApiProjectPerformance';
import ToastMsg from '../../Components/ToastMsg';
import { creators as ProjectPerformanceActions } from '../../Reducers/Reporting/ProjectPerformance';

export function* getProjectPerformanceSummary({ payload }) {
  try {
    const response = yield call(
      ApiProjectPerformance.getSummary,
      payload.selectedYear,
      payload.DateKey,
    );

    if (response.status === 200) {
      yield put(
        ProjectPerformanceActions.projectperformanceSuccess({
          summaryData: response.data,
        }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Project Performance Summary',
            text: response.message,
          },
        },
      );
      yield put(ProjectPerformanceActions.projectperformanceFailure(response.message));
    }
  } catch (e) {
    yield put(ProjectPerformanceActions.projectperformanceFailure(e));
  }
}

export function* getProjectPerformanceDetail({ payload }) {
  try {
    const response = yield call(
      ApiProjectPerformance.getDetail,
      payload.selectedYear,
      payload.DateKey,
    );

    if (response.status === 200) {
      yield put(
        ProjectPerformanceActions.projectperformanceSuccess({
          detailData: response.data,
        }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Project Performance Detail',
            text: response.message,
          },
        },
      );
      yield put(ProjectPerformanceActions.projectperformanceFailure(response.message));
    }
  } catch (e) {
    yield put(ProjectPerformanceActions.projectperformanceFailure(e));
  }
}
